import React from 'react';
import { EmployeeIcon } from '../../../assets/icons/job';
import s from './EmploeesSlideItem.module.scss';

const EmploeesSlideItem = ({employee}) => {
  const {id, src, name, info, thoughts} = employee
  const thirdLabel = info.highlightLabel || 'Достижения';
  const thirdValue = info.highlightValue || info.achievements;

  return (
    <div className={s.emploeesSlideItem}>
      <div className={s.imgWrapper}>
        <img className={s.img} src={src} alt={`employee img ${id}`}/>
      </div>
      <div className={s.info}>

        <div className={s.generalInfo}>
          <h2 className={s.title}>{name}</h2>
          <ol className={s.list}>
            <li className={`${s.li} ${s.text}`}>Город: {info.city}</li>
            <li className={`${s.li} ${s.text}`}>Стаж: {info.experience}</li>
            <li className={`${s.li} ${s.text}`}>{thirdLabel}: {thirdValue}</li>
          </ol>
        </div>

        <div className={s.thoughts}>
          <EmployeeIcon />
          <p className={s.text}>{thoughts}</p>
        </div>

      </div>
    </div>
  )
}

export default EmploeesSlideItem;
